import {
	authenticationConf,
	AuthenticationConf,
	backendConfig,
	dateFnsConfig,
	loggerConfig,
	toastrConf
} from '@config';
import { BackendConfig } from '@eng-ds/api-client';
import { LoggerConfig } from '@eng-ds/logger';
import { NbDateFnsOptions } from '@nebular/date-fns';
import {
	NbComponentStatus,
	NbGlobalPosition,
	NbToastrConfig
} from '@nebular/theme';
import { unflatten } from 'flat';

export interface FlatAppConfig {
	'authentication.loginUrl': string;
	'authentication.baseUrl': string;
	'backend.baseUrl': string;
	'logger.level': number;
	'toastr.duration': number;
	'toastr.icon.icon': string;
	'toastr.icon.status': NbComponentStatus;
	'toastr.position': NbGlobalPosition;
	'dateFns.format': string;
	'gis.url': string;
}

const merge = <T>(dest: T, source: T): T => {
	const target = {} as T;
	// Merge the object into the target object
	const merger = (obj: any) => {
		for (const prop in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, prop)) {
				if (
					Object.prototype.toString.call(obj[prop]) ===
					'[object Object]'
				) {
					// If we're doing a deep merge
					// and the property is an object
					target[prop] = merge(target[prop], obj[prop]);
				} else {
					// Otherwise, do a regular merge
					target[prop] = obj[prop];
				}
			}
		}
	};
	merger(dest);
	merger(source);
	return target;
};

class InternalAppConfig {
	applicationCode: string;
	authentication: AuthenticationConf = authenticationConf;
	backend: Partial<BackendConfig> = backendConfig;
	backendAuth: Partial<BackendConfig> = backendConfig;
	logger: LoggerConfig = loggerConfig;
	toastr: Partial<NbToastrConfig> = toastrConf;
	dateFns: NbDateFnsOptions = dateFnsConfig;
	company: string;
	hostname: string;

	extend(flatAppConfig: FlatAppConfig): InternalAppConfig {
		const target = merge(
			this,
			unflatten<FlatAppConfig, InternalAppConfig>(flatAppConfig)
		);

		return Object.assign(this, target);
	}
}

export const AppConfig = new InternalAppConfig();
